import { Box } from "../../box";
import { forwardRef, useCallback } from "react";
import { isNil, mergeProps, slot, useMergedRefs } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export function InnerSvgImage({
  forwardedRef,
  src,
  ...rest
}) {
  const hideUseElement = useCallback(element => {
    if (!isNil(element)) {
      var _element$querySelecto;

      // Remove auto-generated title if available.
      const titleElement = element.querySelector("title");

      if (!isNil(titleElement)) {
        titleElement.remove();
      } // Hide content from screen readers.


      (_element$querySelecto = element.querySelector("use")) === null || _element$querySelecto === void 0 ? void 0 : _element$querySelecto.setAttribute("aria-hidden", "true");
      element.querySelectorAll("path").forEach(x => {
        x.setAttribute("aria-hidden", "true");
      });
    }
  }, []);
  const ref = useMergedRefs(forwardedRef, hideUseElement);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as: src,
      focusable: false,
      ref,
      // View https://www.scottohara.me/blog/2019/05/22/contextual-images-svgs-and-a11y.html#svgs-that-convey-information
      role: "img"
    })
  });
}
export const SvgImage = slot("image", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerSvgImage, { ...props,
  forwardedRef: ref
})));